/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const TypeNameEnum = {

    /**
     * TODO: Write general description for this element
     */
    DEALS_WON: 'deals_won',

    /**
     * TODO: Write general description for this element
     */
    DEALS_PROGRESSED: 'deals_progressed',

    /**
     * TODO: Write general description for this element
     */
    ACTIVITIES_COMPLETED: 'activities_completed',

    /**
     * TODO: Write general description for this element
     */
    ACTIVITIES_ADDED: 'activities_added',

    /**
     * TODO: Write general description for this element
     */
    DEALS_STARTED: 'deals_started',

};

module.exports = TypeNameEnum;
